<template>
  <footer class="footer">
    <div class="container-fluid">
      <ul class="nav">
      </ul>
      <div class="copyright">
        &copy; {{ year }} OPA Technologies
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
